import { createContext } from "react";

export interface Localization {
  countryId: string;
  [key: string]: string;
}

export const LocalizationContext = createContext<Partial<Localization>>({});
